const fonts = {
  body: '"Gilroy", "Futura", sans-serif',
  heading: '"Futura Std", "Futura", sans-serif;',
  subheading: '"Gilroy", "Futura", sans-serif;',
};

const baseTheme = theme => ({
  colors: {
    background: "#000000",
    body: "#FFFFFF",
    other: ["#000000", "#212121", "#272727", "#2E2E2E"],
    backgroundSecondary: "#212121",
    ...theme.colors,
  },
  fonts,
});

export const inverted = {
  colors: {
    background: "#FFFFFF",
    body: "#000000",
    other: ["#FFFFFF", "#F4F4F4", "#F8F8F8", "#FBFBFB"],
    backgroundSecondary: "#F4F4F4",
  },
  fonts,
};

export const hrd = baseTheme({
  colors: {
    primary: "#E34FA7",
    secondary: "#9DE1EE",
  },
});

export const competition = hrd;

export const event = baseTheme({
  colors: {
    primary: "#DE150D",
    secondary: "#9DE1EE",
  },
});

export const partnership = baseTheme({
  colors: {
    primary: "#4A1895",
    secondary: "#FCE700",
  },
});

export const operational = partnership;

export const finance = baseTheme({
  colors: {
    primary: "#0A4644",
    secondary: "#F7B7D9",
  },
});

export const itdev = finance;

export const marketing = baseTheme({
  colors: {
    primary: "#FA4C27",
    secondary: "#F3E38B",
  },
});

export const academy = marketing;

export const creative = baseTheme({
  colors: {
    primary: "#3C4FAD",
    secondary: "#F8B600",
  },
});

export default baseTheme({
  colors: {
    primary: "#CE3196",
    secondary: "#90F4E8",
  },
});
